import type { RouteObject } from 'react-router';

import { Outlet } from 'react-router';
import { lazy, Suspense } from 'react';

import { CONFIG } from 'src/global-config';
import { DashboardLayout } from 'src/layouts/dashboard';

import { LoadingScreen } from 'src/components/loading-screen';

import { AuthGuard } from 'src/auth/guard';

import { usePathname } from '../../../routes/hooks';

// ----------------------------------------------------------------------

// Ticket
const TicketListPage = lazy(() => import('src/pages/tickets/list'));
const TicketDetailsPage = lazy(() => import('src/pages/tickets/details'));
// ----------------------------------------------------------------------

function SuspenseOutlet() {
  const pathname = usePathname();
  return (
    <Suspense key={pathname} fallback={<LoadingScreen />}>
      <Outlet />
    </Suspense>
  );
}

const TicketLayout = () => (
  <DashboardLayout>
    <SuspenseOutlet />
  </DashboardLayout>
);

export const ticketRoutes: RouteObject[] = [
  {
    path: 'ticket',
    element: CONFIG.auth.skip ? TicketLayout() : <AuthGuard>{TicketLayout()}</AuthGuard>,
    children: [
      { index: true, element: <TicketListPage /> },
      { path: 'list', element: <TicketListPage /> },
      { path: ':id/details', element: <TicketDetailsPage /> },
    ],
  },
];
